import { ReactElement } from "react";
import { Menu, MenuItem, Divider } from "@mui/material";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { Account } from "../../../types";
import { isDemoMode } from "../../../utils/demoMode";

interface AccountMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  selectedAccount: Account | null;
  accountHasTransactions: Record<string, boolean>;
  onEdit: () => void;
  onDuplicate: () => void;
  onArchive: () => void;
  onUnarchive: () => void;
  onDelete: () => void;
}

function AccountMenu({
  anchorEl,
  open,
  onClose,
  selectedAccount,
  accountHasTransactions,
  onEdit,
  onDuplicate,
  onArchive,
  onUnarchive,
  onDelete,
}: AccountMenuProps): ReactElement {
  if (!selectedAccount) {
    return <></>;
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      {selectedAccount.isArchived ? (
        [
          <MenuItem key="unarchive" onClick={onUnarchive}>
            <UnarchiveIcon sx={{ mr: 1, fontSize: 18 }} />
            Unarchive
          </MenuItem>,
          <Divider key="divider1" />,
          <MenuItem
            key="delete"
            onClick={onDelete}
            disabled={accountHasTransactions[selectedAccount.id]}
            sx={{ color: "error.main" }}
          >
            Delete
          </MenuItem>,
        ]
      ) : (
        [
          <MenuItem key="edit" onClick={onEdit}>
            Edit
          </MenuItem>,
          <MenuItem key="duplicate" onClick={onDuplicate}>
            Duplicate
          </MenuItem>,
          <Divider key="divider2" />,
          selectedAccount &&
          (isDemoMode() ||
            accountHasTransactions[selectedAccount.id] ||
            parseFloat(String(selectedAccount.amount || 0)) === 0) ? (
            <MenuItem
              key="archive"
              onClick={onArchive}
              disabled={parseFloat(String(selectedAccount.amount || 0)) !== 0}
              title={
                parseFloat(String(selectedAccount.amount || 0)) !== 0
                  ? "Cannot archive account with non-zero balance. Balance must be 0 to archive."
                  : "Archive this account"
              }
            >
              <ArchiveIcon sx={{ mr: 1, fontSize: 18 }} />
              Archive
            </MenuItem>
          ) : null,
          <MenuItem
            key="delete"
            onClick={onDelete}
            disabled={accountHasTransactions[selectedAccount.id]}
            sx={{ color: "error.main" }}
          >
            Delete
          </MenuItem>,
        ]
      )}
    </Menu>
  );
}

export default AccountMenu;
